<script>
	import {
		doc,
		// collection,
		// addDoc,
		// setDoc,
		getDoc,
		// updateDoc,
		// arrayUnion,
		// onSnapshot,
		// deleteField,
		// serverTimestamp,
		// increment,
	} from "firebase/firestore";
	export let db;
	export let v;
	let activeVersion = Number("2.6" + v.substring(7, 9) + v.substring(5, 7));

	async function checkCurrentVerion(v) {
		const currentVersionSnap = await getDoc(
			doc(db, "version-control", "obelisk"),
		);

		if (currentVersionSnap.exists()) {
			let onlineVersion = currentVersionSnap.data();
			// console.log(onlineVersion.currentVersion, activeVersion);
			if (activeVersion >= onlineVersion.currentVersion) {
				// console.log("Active version is latest version.");
			} else {
				// console.log("Active version is NOT latest version.");

				let url = window.location.href;
				if (url.indexOf("v=") <= -1) {
					if (url.indexOf("?") > -1) {
						url += "&v=" + onlineVersion.currentVersion;
					} else {
						url += "?v=" + onlineVersion.currentVersion;
					}
					document.cookie = "v=" + onlineVersion.currentVersion;
					window.location.href = url;
				}
			}
		} else {
			console.log("No online version can be found!");
		}
	}
	checkCurrentVerion();
</script>
